import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
   //------View without data -------
    rootNoData: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#F7F8FC",
        color: "#9A9AAF",
        height: "224px",
        boxShadow: "inset 0px 4px 4px rgba(0, 0, 0, 0.03)",
        fontWeight: 400,
        fontSize: "14px",
        position: "relative",
      },
      noDataText: {
        fontFamily: "'Inter'",
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: "18px",
        color: "#9A9AAF",
        marginTop: "5px",
        marginBottom: "20px"
      },
      buttonContent : {
        display: 'flex', 
        gap: "5px",
        fontSize: "12px",
        alignItems: "center",
        color: theme.palette.primary.primary800,
      },

      //------View  skeleton -------
      skeleton: {
        width: "100%",
        height: "100%",
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "15px",
        alignItems: "center",
        padding: "20px"
      },
      skeletonContent: {
        height: "80%",
        width: "100%"
      },
      //------View with Data -------
      actionsTopButtons: {
        display: "flex", 
        justifyContent: "end", 
        margin: "9px", 
        gap: "12px",
        alignItems: "center"
      },
      esgContent: {
        position: "relative",
        display: "flex",
        justifyContent: "center",
        gap: "16px",
      }, 
      buttonDesactivation: {
        padding: "6px 12px !important",
        boxShadow: "none"
      },
      buttonStopContent: {
        display: 'flex', 
        gap: "5px",
        fontSize: "12px",
        alignItems: "center",
        color: theme.palette.error.error600
      },
      scoreGraph: {
        borderRadius: "10px",
        background: theme.palette.background.white,
        boxShadow: "0px 6px 16px 0px rgba(21, 12, 115, 0.06)",
        overflow: 'hidden',
        flexShrink: 0, 
        marginTop: "15px",
        "& > div" : {
          height: "100%", 
          borderRadius: "10px",
          fontSize: "26px", 
          fontWeight: 600,
          display: "flex", 
          flexDirection: "column",
          justifyContent: "center"
        }
      },
      scoreLabel : {
        display: "flex", 
        fontWeight: 600, 
        fontSize: "14px", 
        alignItems: "center", 
        justifyContent: "space-between",
        padding: "10px 20px",
        gap: "10px",
        color: theme.palette.black.dark
      },
      buttonHistorique: {
        color: theme.palette.grey.grey600, 
        backgroundColor: theme.palette.grey.grey100,
        padding: "6px 12px !important",
        boxShadow: "none",
      },
      buttonHistoriqueContent: {
        display: 'flex', 
        gap: "5px",
        fontSize: "12px",
        alignItems: "center",
      },
      graphEvolutionDialog: {
        backgroundColor: theme.palette.grey.grey100, 
        padding: "20px 40px"
      },
      graphEvolutionDialogTabsWrapper: {
        paddingLeft: "20px", 
        "button" : {
          textTransform: "none !important", 
          fontWeight: "700", 
          borderBottom: "2px solid " + theme.palette.grey.grey200

        },
        "& .MuiTabs-indicator": {
          backgroundColor: theme.palette.primary.primary600 + " !important",
        },
      },
      graphEvolutionContent: {
        backgroundColor: theme.palette.grey.grey100, 
        minWidth: "685px",
        minHeight: "348px", 
        display: "flex", 
        justifyContent: "center",
        padding: "20px 40px"
      },

      flexCenter: {
        display: "flex", 
        alignItems: "center", 
        justifyContent: "center"
      },
      globalScoreText: {
        borderRadius: "5px", 
        padding: "2px 16px", 
        fontSize: "22px", 
        position: "relative", 
        marginBottom: "5px"
      },
      score5background : {
        background: "linear-gradient(180deg, #FFEBEB -9.6%, rgba(255, 235, 235, 0.00) 55.1%), #FFF",
        color: theme.palette.error.error600
      },
      score4background : {
        background: "linear-gradient(180deg, #FFEBCC -9.6%, rgba(255, 247, 235, 0.00) 55.1%), #FFF",
        color: theme.palette.warning.warning600
      },
      score3background : {
        background: "linear-gradient(180deg, #FFF7EB -9.6%, rgba(255, 247, 235, 0.00) 55.1%), #FFF",
        color: theme.palette.warning.warning500
      },
      score2background : {
        background: "linear-gradient(180deg, rgba(96, 210, 115, 0.50) -9.6%, rgba(96, 210, 115, 0.00) 55.1%), #FFF",
        color: theme.palette.primary.primary400
      }, 
      score1background : {
        background: "linear-gradient(180deg, #D7F4DC -9.6%, rgba(215, 244, 220, 0.00) 55.1%), #FFF",
        color: theme.palette.primary.primary600
      }, 
      scoreUnknownBackground : {
        background: "linear-gradient(180deg ,#D7F4DC -9.6%, rgba(215, 244, 220, 0.00) 55.1%), #FFF",
        color: theme.palette.grey.grey400
      }, 
      scoreGlobalDetails : {
        background: "linear-gradient(90deg, rgb(71 233 255 / 9%) 0%, rgb(228 213 237 / 14%) 100%)",
        padding: "15px 20px 15px 20px", 
        display: "grid", 
        gridTemplateColumns: "32px 1fr",
        columnGap: "12px", 
        rowGap: "24px",
        borderRadius: "10px"
      },
      globalDataDepth: {
        color: theme.palette.grey.grey600,
        fontSize: "32px",
        fontWeight: 700
      },
      leftBarRisk : {
        borderLeft: "4px solid", 
        paddingLeft: "11px", 
        fontWeight: 700
      },

      scoreDetails: {
        position: "relative",
        display: "grid", 
        gridTemplateColumns: "1fr 0.3fr",
        alignItems: "center", 
        maxWidth: "500px",
        borderRadius: "10px",
        background: "linear-gradient(90deg, rgb(71 233 255 / 9%) 0%, rgb(228 213 237 / 14%) 100%)",
        padding: "10px 20px 10px 20px", 
        columnGap: "20px", 
        "& > div:first-of-type" : {
          borderRight: "1px solid " + theme.palette.grey.grey300,
          paddingRight: "20px"
        }
      },
      scoreDetailsContent: {
        display: "flex", 
        alignItems: "center", 
        borderRadius: "24px",
        gap: "10px", 
        padding: "6px", 
        fontSize: "14px", 
        fontWeight: "600", 
        backgroundColor: "#FFF", 
        boxShadow: "0px 6px 16px 0px rgba(21, 12, 115, 0.06);",
        marginBottom: "6px", 
      },
      dataDepthSection: {
        "& > div": {
          backgroundColor: "unset !important",
          boxShadow: "unset !important"
        },
      },     
      scoreDetailsSection : {
        color: theme.palette.grey.grey400,
        fontWeight: "600", 
        lineHeight: "16px", 
        fontSize: "12px", 
        paddingBottom: "8px"
      },
      squareScore: {
        width: "30px", 
        height: "20px", 
        display: "flex", 
        borderRadius: "16px",
        justifyContent: "center",
        color: "#FFF"
      },
      openDetailsbutton: {
        width: "20px",
        height: "20px",
        border: "1px solid " + theme.palette.grey.grey300,
        borderRadius: "16px",
        display: "flex",
        padding: "2px",
        marginLeft: "auto", 
        backgroundColor: theme.palette.grey.grey100,
        "&:hover": {
          cursor: "pointer", 
          backgroundColor: theme.palette.grey.grey200
        }
      },
      openGlobalDetailsbutton: {
        border: "1px solid " + theme.palette.grey.grey300,
        borderRadius: "16px",
        display: "flex",
        gap: "5px",
        padding: "2px 10px",
        marginLeft: "auto", 
        color: theme.palette.grey.grey500,
        fontSize: "12px",
        fontWeight: 600,
        backgroundColor: "#FFF",
        "&:hover": {
          cursor: "pointer", 
          backgroundColor: theme.palette.grey.grey100
        }
      },
      iconeRiskEvolution : {
        borderRadius: "200px",
        boxShadow: "0px 18px 40px 0px rgba(112, 144, 176, 0.12)",
        width: "20px",
        height: "20px",
        position: "absolute",
        left: "-10px",
        top: "8px",

        display: "flex", 
        alignItems: "center", 
        justifyContent: "center",
      },
      infobulle : {
        display: "flex", 
        alignItems: "center"
      },
      dialogStop : {
        display: "flex", 
        flexDirection: "column", 
        alignItems: "center", 
        justifyContent: "center",
        gap: "32px"
      }, 
      dialogStopContent: {
        display: "flex", 
        flexDirection: "column", 
        alignItems: "center", 
        justifyContent: "center",
        gap: "16px", 
        alignSelf: "stretch"
      }, 
      dialogStopIcon: {
        display: "flex", 
        alignItems: "center", 
        justifyContent: "center",
        width: "55px", 
        height: "55px",
        borderRadius: "78px", 
        backgroundColor: theme.palette.error.error100
      }, 
      dialogStopActions: {
        display: "flex", 
        gap: "16px", 
      }
}));

export default useStyles;